<template>
  <div
    class="menu"
    :class="{
      open: Open,
    }"
  >
    <TransitionGroup name="fade">
      <div
        key="Caracteristicas"
        v-if="Content == 'caracteristicas'"
        class="menu__caracteristicas"
      >
        <div
          class="menu__caracteristicas__tipos"
          :class="{
            hidden: unSoloTipo,
            error: aplicacion.coleccionSel.sideSel.Live.EsError(
              aplicacion.coleccionSel.sideSel.Live.perfil
            ),
          }"
        >
          <div class="menu__caracteristicas__tipos__title">
            {{
              aplicacion.languageSel == "es"
                ? "Configuración"
                : aplicacion.languageSel == "en"
                ? "Settings"
                : aplicacion.languageSel == "fr"
                ? "Paramètres"
                : aplicacion.languageSel == "de"
                ? "Einstellungen"
                : aplicacion.languageSel == "it"
                ? "Impostazioni"
                : aplicacion.languageSel == "pt"
                ? "Configurações"
                : ""
            }}
          </div>

          <div class="menu__caracteristicas__tipos__items">
            <div
              @click="SetType()"
              class="menu__caracteristicas__tipos__items__item"
              :class="{
                active: aplicacion.tipo == 'estandar',
              }"
            >
              {{
                aplicacion.languageSel == "es"
                  ? "Estándar"
                  : aplicacion.languageSel == "en"
                  ? "Standard"
                  : aplicacion.languageSel == "fr"
                  ? "Standard"
                  : aplicacion.languageSel == "de"
                  ? "Standard"
                  : aplicacion.languageSel == "it"
                  ? "Standard"
                  : aplicacion.languageSel == "pt"
                  ? "Padrão"
                  : ""
              }}
            </div>
            <div
              @click="SetType()"
              class="menu__caracteristicas__tipos__items__item"
              :class="{
                active: aplicacion.tipo == 'configurable',
              }"
            >
              {{
                aplicacion.languageSel == "es"
                  ? "Personalizada"
                  : aplicacion.languageSel == "en"
                  ? "Custom"
                  : aplicacion.languageSel == "fr"
                  ? "Personnalisé"
                  : aplicacion.languageSel == "de"
                  ? "Individuell angefertigt"
                  : aplicacion.languageSel == "it"
                  ? "Personalizzato"
                  : "Personalizado"
              }}
            </div>
          </div>
        </div>
        <div class="menu__caracteristicas__grupos">
          <div
            v-for="(Grupo, GrupoIndex) in aplicacion.coleccionSel.sideSel.Live
              .grupos"
            :key="GrupoIndex"
            class="menu__caracteristicas__grupos__item"
            @click="SetGrupo(Grupo)"
            :class="{
              active: Grupo.cod == aplicacion.grupoSel.Live.cod,
              hidden: SetAdicionales(Grupo),
            }"
          >
            <div class="menu__caracteristicas__grupos__item__grupo">
              <div
                class="menu__caracteristicas__grupos__item__grupo__name"
                :class="{
                  error: Grupo.EsError(
                    aplicacion.coleccionSel.sideSel.Live.perfil
                  ),
                }"
              >
                <img
                  src="@/assets/Images/Global/Error.svg"
                  alt=""
                  class="menu__caracteristicas__grupos__item__grupo__name__error"
                />
                <p
                  class="menu__caracteristicas__grupos__item__grupo__name__texto"
                >
                  {{ Grupo.GetLiteral(aplicacion.languageSel) }}
                </p>
              </div>
              <img
                src="@/assets/Images/Global/Expand.svg"
                alt=""
                class="menu__caracteristicas__grupos__item__grupo__expand"
              />
            </div>
            <div
              class="menu__caracteristicas__grupos__item__separator"
              :class="{
                hidden:
                  GrupoIndex ==
                    aplicacion.coleccionSel.sideSel.Live.grupos.findIndex(
                      (Element) => Element.cod == aplicacion.grupoSel.Live.cod
                    ) -
                      1 ||
                  (Grupo.cod == 'TIRADOR' &&
                    aplicacion.grupoSel.Live.cod == 'REVESTIMIENTO' &&
                    SetAdicionales(
                      aplicacion.coleccionSel.sideSel.Live.grupos[
                        aplicacion.coleccionSel.sideSel.Live.grupos.findIndex(
                          (grupoEl) => grupoEl.cod == 'ADICIONALES'
                        )
                      ]
                    )),
              }"
            ></div>
          </div>
          <div class="menu__caracteristicas__grupos__separator"></div>
        </div>
        <TransitionGroup
          @before-enter="onBeforeEnter"
          @enter="onEnter"
          @after-enter="onAfterEnter"
          @enter-cancelled="onEnterCancelled"
          @before-leave="onBeforeLeave"
          @leave="onLeave"
          @after-leave="onAfterLeave"
          @leave-cancelled="onLeaveCancelled"
          class="menu__caracteristicas__campos"
        >
          <div
            v-for="(Campo, CampoIndex) in aplicacion.grupoSel.Delay.campos"
            :key="Campo.cod + CampoIndex"
            v-if="
              Campo.Resolve(aplicacion.coleccionSel.sideSel.Live.perfil) &&
              Campo.visible
            "
            class="menu__caracteristicas__campos__item"
            :tipo="Campo.tipo"
            :error="Campo.EsError(aplicacion.coleccionSel.sideSel.Live.perfil)"
          >
            <div
              v-if="Campo.tipo == 'tacos'"
              class="menu__caracteristicas__campos__item__acabados"
            >
              <div class="menu__caracteristicas__campos__item__acabados__title">
                <p
                  class="menu__caracteristicas__campos__item__acabados__title__text"
                >
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </p>
                <div
                  class="menu__caracteristicas__campos__item__acabados__title__ayuda"
                  v-if="Campo.ayuda != undefined"
                >
                  <img
                    src="@/assets/Images/Global/Info.svg"
                    alt=""
                    class="menu__caracteristicas__campos__item__acabados__title__ayuda__info"
                  />
                  <p
                    class="menu__caracteristicas__campos__item__acabados__title__ayuda__text"
                  >
                    {{ Campo.ayuda }}
                  </p>
                </div>
              </div>
              <TransitionGroup
                name="tacos"
                class="menu__caracteristicas__campos__item__acabados__items"
              >
                <div
                  v-for="(Acabado, AcabadoIndex) in Campo.acabados"
                  :key="Acabado.cod + AcabadoIndex"
                  v-if="
                    Acabado.Resolve(
                      aplicacion.coleccionSel.sideSel.Live.perfil
                    ) || Campo.acabadoSel.cod == Acabado.cod
                  "
                  class="menu__caracteristicas__campos__item__acabados__items__item"
                  :class="{
                    active: Campo.acabadoSel.cod == Acabado.cod,
                    error:
                      !Acabado.Resolve(
                        aplicacion.coleccionSel.sideSel.Live.perfil
                      ) && Campo.acabadoSel.cod == Acabado.cod,
                  }"
                >
                  <div
                    v-if="Acabado.modal"
                    @click="SetModal(GetModal(Campo, Acabado))"
                    class="menu__caracteristicas__campos__item__acabados__items__item__detalle"
                  >
                    <img
                      src="@/assets/Images/Global/Add.svg"
                      alt=""
                      class="menu__caracteristicas__campos__item__acabados__items__item__detalle__image"
                    />
                  </div>
                  <div
                    @click="
                      SetAcabado(
                        $event,
                        aplicacion.grupoSel.Live,
                        Campo,
                        Acabado
                      )
                    "
                    class="menu__caracteristicas__campos__item__acabados__items__item__miniatura skeleton"
                  >
                    <img
                      @load="ResolveImage($event)"
                      :src="RequireImage('Tacos', GetTaco(Campo, Acabado))"
                      alt=""
                      class="menu__caracteristicas__campos__item__acabados__items__item__miniatura__image"
                    />
                    <div
                      class="menu__caracteristicas__campos__item__acabados__items__item__miniatura__error"
                    >
                      <img
                        src="@/assets/Images/Global/Error.svg"
                        alt=""
                        class="menu__caracteristicas__campos__item__acabados__items__item__miniatura__error__image"
                      />
                      <p
                        class="menu__caracteristicas__campos__item__acabados__items__item__miniatura__error__texto"
                      >
                        No disponible
                      </p>
                    </div>
                  </div>
                  <p
                    class="menu__caracteristicas__campos__item__acabados__items__item__name"
                  >
                    {{ Acabado.GetLiteral(aplicacion.languageSel) }}
                  </p>
                </div>
              </TransitionGroup>
            </div>

            <div
              v-if="Campo.tipo == 'filtro'"
              class="menu__caracteristicas__campos__item__compuesto"
            >
              <div
                class="menu__caracteristicas__campos__item__compuesto__title"
              >
                <p
                  class="menu__caracteristicas__campos__item__compuesto__title__text"
                >
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </p>
                <div
                  class="menu__caracteristicas__campos__item__compuesto__title__ayuda"
                  v-if="Campo.ayuda != undefined"
                >
                  <img
                    src="@/assets/Images/Global/Info.svg"
                    alt=""
                    class="menu__caracteristicas__campos__item__compuesto__title__ayuda__info"
                  />
                  <p
                    class="menu__caracteristicas__campos__item__compuesto__title__ayuda__text"
                  >
                    {{ Campo.ayuda }}
                  </p>
                </div>
              </div>
              <div
                class="menu__caracteristicas__campos__item__compuesto__filtros"
                v-if="Campo.filtros.length == 2"
              >
                <div
                  v-for="(Filtro, FiltroIndex) in Campo.filtros"
                  :key="Filtro.cod + FiltroIndex"
                  class="menu__caracteristicas__campos__item__compuesto__filtros__item"
                  @click="SetFiltro($event, Campo, Filtro)"
                  :class="{
                    active: Filtro.cod == Campo.filtroSel.Live.cod,
                  }"
                >
                  {{ Filtro.GetLiteral(aplicacion.languageSel) }}
                </div>
              </div>
              <TransitionGroup
                name="tacos"
                class="menu__caracteristicas__campos__item__compuesto__items"
              >
                <div
                  v-for="(Acabado, AcabadoIndex) in Campo.GetFiltro(
                    Campo.filtroSel.Delay.cod
                  ).acabados"
                  :key="Acabado.cod + AcabadoIndex"
                  v-if="
                    Acabado.Resolve(
                      aplicacion.coleccionSel.sideSel.Live.perfil
                    ) ||
                    Campo.GetFiltro(Campo.filtroSel.Delay.cod).acabadoSel.cod ==
                      Acabado.cod
                  "
                  class="menu__caracteristicas__campos__item__compuesto__items__item"
                  :class="{
                    active:
                      Campo.GetFiltro(Campo.filtroSel.Delay.cod).acabadoSel
                        .cod == Acabado.cod,
                    error:
                      !Acabado.Resolve(
                        aplicacion.coleccionSel.sideSel.Live.perfil
                      ) &&
                      Campo.GetFiltro(Campo.filtroSel.Delay.cod).acabadoSel
                        .cod == Acabado.cod,
                  }"
                >
                  <div
                    v-if="Acabado.modal"
                    @click="SetModal(GetModal(Campo, Acabado))"
                    class="menu__caracteristicas__campos__item__compuesto__items__item__detalle"
                  >
                    <img
                      src="@/assets/Images/Global/Add.svg"
                      alt=""
                      class="menu__caracteristicas__campos__item__compuesto__items__item__detalle__image"
                    />
                  </div>
                  <div
                    @click="
                      SetAcabadoCompuesto(
                        Campo,
                        Campo.GetFiltro(Campo.filtroSel.Delay.cod),
                        Acabado
                      )
                    "
                    class="menu__caracteristicas__campos__item__compuesto__items__item__miniatura skeleton"
                  >
                    <img
                      @load="ResolveImage($event)"
                      :src="RequireImage('Tacos', GetTaco(Campo, Acabado))"
                      alt=""
                      class="menu__caracteristicas__campos__item__compuesto__items__item__miniatura__image"
                    />
                    <div
                      class="menu__caracteristicas__campos__item__compuesto__items__item__miniatura__error"
                    >
                      <img
                        src="@/assets/Images/Global/Error.svg"
                        alt=""
                        class="menu__caracteristicas__campos__item__compuesto__items__item__miniatura__error__image"
                      />
                      <p
                        class="menu__caracteristicas__campos__item__compuesto__items__item__miniatura__error__texto"
                      >
                        No disponible
                      </p>
                    </div>
                  </div>
                  <p
                    class="menu__caracteristicas__campos__item__compuesto__items__item__name"
                  >
                    {{ Acabado.GetLiteral(aplicacion.languageSel) }}
                  </p>
                </div>
              </TransitionGroup>
            </div>

            <div
              v-else-if="Campo.tipo == 'dropdown'"
              class="menu__caracteristicas__campos__item__dropdown"
            >
              <div class="menu__caracteristicas__campos__item__dropdown__title">
                <p
                  class="menu__caracteristicas__campos__item__dropdown__title__text"
                >
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </p>
                <div
                  class="menu__caracteristicas__campos__item__dropdown__title__ayuda"
                  v-if="Campo.ayuda != undefined"
                >
                  <img
                    src="@/assets/Images/Global/Info.svg"
                    alt=""
                    class="menu__caracteristicas__campos__item__dropdown__title__ayuda__info"
                  />
                  <p
                    class="menu__caracteristicas__campos__item__dropdown__title__ayuda__text"
                  >
                    {{ Campo.ayuda }}
                  </p>
                </div>
              </div>
              <div
                class="menu__caracteristicas__campos__item__dropdown__item"
                @click="OpenInput($event)"
              >
                <div
                  class="menu__caracteristicas__campos__item__dropdown__item__selected"
                >
                  <div
                    class="menu__caracteristicas__campos__item__dropdown__item__selected__value"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </div>
                  <img
                    src="@/assets/Images/Global/Expand.svg"
                    alt=""
                    class="menu__caracteristicas__campos__item__dropdown__item__selected__expand"
                  />
                </div>
                <div
                  class="menu__caracteristicas__campos__item__dropdown__item__values"
                >
                  <div
                    v-for="(Value, ValueIndex) in Campo.acabados"
                    :key="ValueIndex"
                    v-if="
                      Value.Resolve(aplicacion.coleccionSel.sideSel.Live.perfil)
                    "
                    class="menu__caracteristicas__campos__item__dropdown__item__values__item"
                    @click="
                      SetAcabado($event, aplicacion.grupoSel.Live, Campo, Value)
                    "
                    :class="{
                      active: Campo.acabadoSel.cod == Value.cod,
                    }"
                  >
                    {{ Value.GetLiteral(aplicacion.languageSel) }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="Campo.tipo == 'input'"
              class="menu__caracteristicas__campos__item__input"
              :class="{
                error: Campo.EsError(
                  aplicacion.coleccionSel.sideSel.Live.perfil
                ),
              }"
            >
              <div class="menu__caracteristicas__campos__item__input__title">
                <p
                  class="menu__caracteristicas__campos__item__input__title__text"
                >
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </p>
                <div
                  class="menu__caracteristicas__campos__item__input__title__ayuda"
                  v-if="Campo.ayuda != undefined"
                >
                  <img
                    src="@/assets/Images/Global/Info.svg"
                    alt=""
                    class="menu__caracteristicas__campos__item__input__title__ayuda__info"
                  />
                  <p
                    class="menu__caracteristicas__campos__item__input__title__ayuda__text"
                  >
                    {{ Campo.ayuda }}
                  </p>
                </div>
              </div>
              <div class="menu__caracteristicas__campos__item__input__items">
                <div
                  class="menu__caracteristicas__campos__item__input__items__item"
                >
                  <input
                    :placeholder="Campo.value"
                    v-model="Campo.value"
                    @input="
                      SetInputValue(
                        aplicacion.grupoSel.Live,
                        Campo,
                        Campo.value
                      )
                    "
                    class="menu__caracteristicas__campos__item__input__items__item__input"
                    type="text"
                  />
                  <p
                    v-if="Campo.medida != undefined"
                    class="menu__caracteristicas__campos__item__input__items__item__unit"
                  >
                    mm
                  </p>
                </div>
                <p
                  v-if="Campo.medida != undefined"
                  class="menu__caracteristicas__campos__item__input__items__error"
                >
                  Min. {{ Campo.medida.minimo }} mm - Max.
                  {{ Campo.medida.maximo }} mm
                </p>
              </div>
            </div>
            <div
              class="menu__caracteristicas__campos__item__toggle"
              v-else-if="Campo.tipo == 'toggle'"
            >
              <div class="menu__caracteristicas__campos__item__toggle__title">
                <p
                  class="menu__caracteristicas__campos__item__toggle__title__text"
                >
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </p>
                <div
                  class="menu__caracteristicas__campos__item__toggle__title__ayuda"
                  v-if="Campo.ayuda != undefined"
                >
                  <img
                    src="@/assets/Images/Global/Info.svg"
                    alt=""
                    class="menu__caracteristicas__campos__item__toggle__title__ayuda__info"
                  />
                  <p
                    class="menu__caracteristicas__campos__item__toggle__title__ayuda__text"
                  >
                    {{ Campo.ayuda }}
                  </p>
                </div>
              </div>
              <toggle-button
                @change="
                  SetAcabado(
                    $event,
                    aplicacion.grupoSel.Live,
                    Campo,
                    Campo.acabados[
                      Campo.acabados.findIndex(
                        (Acabado) => Acabado.cod != Campo.acabadoSel.cod
                      )
                    ]
                  )
                "
                :sync="true"
                :value="Campo.acabadoSel.cod == '0' ? false : true"
                class="menu__caracteristicas__campos__item__toggle__toggle"
                :height="20"
                :width="35"
                color="#4c88b7"
              />
            </div>
          </div>
        </TransitionGroup>
      </div>
      <div
        key="Grupos"
        v-else-if="Content == 'grupos'"
        class="menu__grupos"
        :class="{
          hiddenTipos: unSoloTipo,
        }"
      >
        <div class="menu__grupos__tipos">
          <div class="menu__grupos__tipos__title">{{}}</div>
          <div class="menu__grupos__tipos__items">
            <div
              @click="SetType()"
              class="menu__grupos__tipos__items__item"
              :class="{
                active: aplicacion.tipo == 'estandar',
              }"
            >
              En Stock
            </div>
            <div
              @click="SetType()"
              class="menu__grupos__tipos__items__item"
              :class="{
                active: aplicacion.tipo == 'configurable',
              }"
            >
              Personalizada
            </div>
          </div>
        </div>
        <div
          v-for="(Grupo, GrupoIndex) in aplicacion.coleccionSel.sideSel.Live
            .grupos"
          :key="GrupoIndex"
          @click="SetGrupo(Grupo)"
          class="menu__grupos__item"
          :class="{
            error: Grupo.EsError(aplicacion.coleccionSel.sideSel.Live.perfil),
            hidden: SetAdicionales(Grupo),
          }"
        >
          <img
            src="@/assets/Images/Global/Error.svg"
            alt=""
            class="menu__grupos__item__error"
          />
          <p class="menu__grupos__item__text">
            {{ Grupo.GetLiteral(aplicacion.languageSel) }}
          </p>
        </div>
      </div>
      <div key="Resumen" v-else-if="Content == 'resumen'" class="menu__resumen">
        <div class="menu__resumen__top">
          <p class="menu__resumen__top__title">Resumen</p>
        </div>
        <TransitionGroup
          @before-enter="onBeforeEnter"
          @enter="onEnter"
          @after-enter="onAfterEnter"
          @enter-cancelled="onEnterCancelled"
          @before-leave="onBeforeLeave"
          @leave="onLeave"
          @after-leave="onAfterLeave"
          @leave-cancelled="onLeaveCancelled"
          class="menu__resumen__grupos"
        >
          <div
            v-for="(Grupo, GrupoIndex) in aplicacion.coleccionSel.sideSel.Delay
              .grupos"
            :key="GrupoIndex"
            class="menu__resumen__grupos__item"
            :class="{
              hidden:
                SetAdicionales(Grupo) ||
                (Grupo.cod == 'REVESTIMIENTO' && aplicacion.tipo != 'estandar'),
            }"
          >
            <p
              class="menu__resumen__grupos__item__title"
              v-if="Grupo.cod != 'REVESTIMIENTO'"
            >
              {{ Grupo.GetLiteral(aplicacion.languageSel) }}
            </p>
            <p
              class="menu__resumen__grupos__item__title"
              v-if="
                aplicacion.tipo == 'estandar' && Grupo.cod == 'REVESTIMIENTO'
              "
            >
              {{
                aplicacion.languageSel == "es"
                  ? "Código"
                  : aplicacion.languageSel == "en"
                  ? "Code"
                  : aplicacion.languageSel == "fr"
                  ? "Code"
                  : aplicacion.languageSel == "de"
                  ? "Code"
                  : aplicacion.languageSel == "it"
                  ? "Codice"
                  : ""
              }}
            </p>
            <TransitionGroup
              @before-enter="onBeforeEnter"
              @enter="onEnter"
              @after-enter="onAfterEnter"
              @enter-cancelled="onEnterCancelled"
              @before-leave="onBeforeLeave"
              @leave="onLeave"
              @after-leave="onAfterLeave"
              @leave-cancelled="onLeaveCancelled"
              class="menu__resumen__grupos__item__campos"
              v-if="Grupo.cod != 'REVESTIMIENTO'"
            >
              <div
                v-for="(Campo, CampoIndex) in Grupo.campos"
                :key="CampoIndex"
                v-if="
                  Campo.Resolve(aplicacion.coleccionSel.sideSel.Delay.perfil) &&
                  Campo.visible &&
                  !(
                    Campo.cod == 'TIPO_VIDRIO' && Campo.acabadoSel.cod == '04'
                  ) &&
                  !(Campo.cod == 'COLOR_DECORADO' && Campo.tipo != 'filtro') &&
                  !(
                    Campo.cod == 'COLOR_PERFIL_ST' &&
                    Campo.acabadoSel.cod == 'RL'
                  )
                "
                class="menu__resumen__grupos__item__campos__item"
              >
                <div
                  v-if="Campo.tipo != 'filtro'"
                  class="menu__resumen__grupos__item__campos__item__title"
                >
                  <p
                    class="menu__resumen__grupos__item__campos__item__title__campo"
                  >
                    {{ Campo.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <p
                    v-if="Campo.tipo == 'tacos'"
                    class="menu__resumen__grupos__item__campos__item__title__value"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                </div>
                <div
                  v-else
                  class="menu__resumen__grupos__item__campos__item__title"
                >
                  <p
                    class="menu__resumen__grupos__item__campos__item__title__campo"
                  >
                    {{ Campo.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <p
                    class="menu__resumen__grupos__item__campos__item__title__value"
                  >
                    {{
                      Campo.filtroSel.Delay.acabadoSel.GetLiteral(
                        aplicacion.languageSel
                      ) +
                      " " +
                      Campo.acabadoSel
                        .GetLiteral(aplicacion.languageSel)
                        .toLowerCase()
                    }}
                  </p>
                </div>
                <div
                  v-if="Campo.tipo == 'tacos'"
                  class="menu__resumen__grupos__item__campos__item__miniatura skeleton"
                >
                  <img
                    @load="ResolveImage($event)"
                    :src="
                      RequireImage('Tacos', GetTaco(Campo, Campo.acabadoSel))
                    "
                    alt=""
                    class="menu__resumen__grupos__item__campos__item__miniatura__image"
                  />
                </div>
                <div
                  v-else-if="Campo.tipo == 'filtro'"
                  class="menu__resumen__grupos__item__campos__item__miniatura skeleton"
                >
                  <img
                    @load="ResolveImage($event)"
                    :src="
                      RequireImage(
                        'Tacos',
                        GetTaco(Campo, Campo.filtroSel.Delay.acabadoSel)
                      )
                    "
                    alt=""
                    class="menu__resumen__grupos__item__campos__item__miniatura__image"
                  />
                </div>
                <p
                  v-else-if="Campo.tipo == 'dropdown'"
                  class="menu__resumen__grupos__item__campos__item__value"
                >
                  {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  <span v-if="Campo.medida != undefined"> mm</span>
                </p>
                <p
                  v-else-if="Campo.tipo == 'input'"
                  class="menu__resumen__grupos__item__campos__item__value"
                >
                  {{ Campo.value }}
                  <span v-if="Campo.medida != undefined"> mm</span>
                </p>
                <p
                  v-else-if="Campo.tipo == 'toggle'"
                  class="menu__resumen__grupos__item__campos__item__value"
                >
                  {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                </p>
              </div>
            </TransitionGroup>
            <div
              v-if="
                Grupo.cod == 'REVESTIMIENTO' && aplicacion.tipo == 'estandar'
              "
            >
              {{ aplicacion.priceObj.codigo }}
            </div>
          </div>
        </TransitionGroup>
        <div class="menu__resumen__bottom">
          <button
            class="menu__resumen__bottom__buy"
            @click="$root.$emit('DownloadPDF')"
          >
            <p>
              {{
                aplicacion.languageSel == "es"
                  ? "Imprimir configuración"
                  : aplicacion.languageSel == "en"
                  ? "Print settings"
                  : aplicacion.languageSel == "fr"
                  ? "Imprimer les paramètres"
                  : aplicacion.languageSel == "de"
                  ? "Druckeinstellungen"
                  : aplicacion.languageSel == "it"
                  ? "Impostazioni di stampa"
                  : ""
              }}
            </p>

            <img
              src="@/assets/Images/Global/Loader.svg"
              alt=""
              class="menu__resumen__bottom__buy__loader"
              :class="{
                hidden: Hidden,
              }"
            />
          </button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "Menu",
  data() {
    return {
      Hidden: true,
    };
  },
  props: {
    Open: Boolean,
    Content: String,
    aplicacion: Object,
    unSoloTipo: Boolean,
    privada: String,
  },
  components: {
    ToggleButton,
  },
  mounted() {
    this.$root.$on("SetDondeComprar", () => {
      this.SetDondeComprar();
    });
    this.$root.$on("SetDownloadPDFLoader", (bool) => {
      this.Hidden = bool;
    });
  },
  methods: {
    SetAdicionales(Grupo) {
      var status = false;
      status = Grupo.campos.every(
        (campo) =>
          campo.visible === false ||
          campo.Resolve(this.aplicacion.coleccionSel.sideSel.Live.perfil) ===
            false
      );
      if (status) {
        if (Grupo.cod == this.aplicacion.grupoSel.Live.cod) {
          this.SetGrupo(this.aplicacion.coleccionSel.sideSel.Live.grupos[0]);
        }
      }
      return status;
    },
    SetDondeComprar() {
      var detalle = this.aplicacion.coleccionSel.sideSel.Live.priceObj;
      var canvas;
      if (window.location.href.includes("8081")) {
        canvas = document.getElementsByClassName("canvas__slider__item")[
          this.aplicacion.coleccionSel.sideSel.Live.cod == "left" ? 0 : 1
        ];
      } else {
        canvas = document
          .querySelector("c-selector")
          .shadowRoot.querySelectorAll(".canvas__slider__item")[
          this.aplicacion.coleccionSel.sideSel.Live.cod == "left" ? 0 : 1
        ];
      }

      console.log(canvas);

      var image;

      try {
        image = canvas.toDataURL("image/webp", 0.75);
        console.log("OK - CAPTURA DE CANVAS", image);
      } catch (error) {
        image = this.RequireImage(
          "Colecciones/1000",
          this.aplicacion.coleccionSel.cod.toUpperCase() +
            "/" +
            this.aplicacion.coleccionSel.cod.toUpperCase() +
            "&FONDO.webp"
        );
        console.log("ERROR - CAPTURA DE CANVAS", error);
        console.log(image);
      }

      detalle.escena = image;

      let codCampo = "MONTAJE";
      if (this.aplicacion.tipo == "estandar") {
        codCampo = "montaje";
      }

      if (this.aplicacion.montajeExists()) {
        detalle.montaje =
          this.aplicacion.coleccionSel.sideSel.Live.GetCampo(
            codCampo
          ).acabadoSel.cod;
      } else {
        detalle.montaje = 0;
      }

      // if (
      //   this.aplicacion.coleccionSel.sideSel.Live.GetCampo(codCampo) !=
      //     undefined ||
      //   this.aplicacion.coleccionSel.sideSel.Live.GetCampo(codCampo) != "" ||
      //   this.aplicacion.coleccionSel.sideSel.Live.GetCampo(codCampo) != null
      // ) {
      //   detalle.montaje =
      //     this.aplicacion.coleccionSel.sideSel.Live.GetCampo(
      //       codCampo
      //     ).acabadoSel.cod;
      // } else {
      //   detalle.montaje = 0;
      // }

      let miEvento = new CustomEvent("3drender-open-comprar", {
        detail: detalle,
      });
      window.dispatchEvent(miEvento);
    },
    SetInputValue(Grupo, Campo, Value) {
      Campo.EsError(this.aplicacion.coleccionSel.sideSel.Live.perfil);
      this.$emit("Acabado", Grupo, Campo, Value);
    },
    SetModal(Image) {
      this.$root.$emit("Modal", "Detalle", Image);
    },
    onBeforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = "translate(0, -25px)";
    },
    onEnter(el, done) {
      setTimeout(() => {
        done();
      }, 1);
    },
    onAfterEnter(el) {
      el.style.opacity = 1;
      el.style.transform = "revert";
    },
    onEnterCancelled(el) {},
    onBeforeLeave(el) {},
    onLeave(el, done) {
      done();
    },
    onAfterLeave(el) {},
    onLeaveCancelled(el) {},
    ResolveImage(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      element.parentNode.classList.remove("skeleton");

      setTimeout(() => {
        element.style.opacity = 1;
        var Detalle = element.parentNode.parentNode.children[0];
        if (
          Detalle.classList.contains(
            "menu__caracteristicas__campos__item__acabados__items__item__detalle"
          )
        ) {
          Detalle.style.opacity = 1;
        }
      }, 50);
    },
    RequireImage(Folder, url) {
      var Image;
      try {
        Image = require("@/assets/Images/" + Folder + "/" + url);
      } catch (error) {
        //console.log("%c" + Folder + "/" + url, "color:red");
        Image = require("@/assets/Images/Global/Error.webp");
      }
      return Image;
    },
    SetType() {
      this.$emit("Type");
    },
    SetGrupo(Object) {
      this.$emit("Grupo", Object);
    },
    SetFiltro(e, CampoObject, FiltroObject) {
      this.$emit("Filtro", CampoObject, FiltroObject);

      this.SetAcabadoCompuesto(
        CampoObject,
        FiltroObject,
        FiltroObject.acabadoSel
      );
    },
    SetAcabado(e, GrupoObject, CampoObject, AcabadoObject) {
      //console.log(GrupoObject, CampoObject, AcabadoObject);
      if (CampoObject.tipo == "dropdown") {
        var element;
        if (e.target == null || e.target == undefined) {
          element = e.path[0];
        } else {
          element = e.target;
        }
        var Input = element.parentNode.parentNode;
        var Value = Input.children[0].children[0];
        Value.style.opacity = 0;
        setTimeout(() => {
          Input.classList.remove("open");
          setTimeout(() => {
            this.$emit("Acabado", GrupoObject, CampoObject, AcabadoObject);
            Value.style.opacity = 1;
          }, 250);
        }, 100);
      } else {
        this.$emit("Acabado", GrupoObject, CampoObject, AcabadoObject);
      }
    },
    SetAcabadoCompuesto(Campo, FiltroObject, AcabadoObject) {
      this.$emit("AcabadoCompuesto", Campo, FiltroObject, AcabadoObject);
    },
    OpenInput(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      var Input = element;

      if (
        element.classList.contains(
          "menu__caracteristicas__campos__item__dropdown__item__selected"
        )
      ) {
        Input = element.parentNode;
      } else {
        Input = element.parentNode.parentNode;
      }

      var Campos = Input.parentNode.parentNode.parentNode.children;
      for (const Campo of Campos) {
        if (Campo.getAttribute("tipo") == "dropdown") {
          if (Campo.children[0].children[1] != Input) {
            Campo.children[0].children[1].classList.remove("open");
          }
        }
      }

      Input.classList.toggle("open");
    },
    GetNombreArchivo(campo, acabado) {
      // Este método está Hardcodeado para transformar el nombre de la característica en una
      // aplicación de tipo estándar.
      // Vidrio hay que hardcodearlo porque en realidad lo forman 2 campos (vidrio y decorado) que
      // nos llegan sólo en 1.
      // El resto podría hacerse sin hardcode con la excel de converión configurable/estándar pero
      // son tan pocos los códigos que por el momento se queda así.
      // Si se diera más casuística se cambiaría.
      let nombre;

      if (campo.compuesto != undefined) {
        if (
          campo.cod == "tirador" ||
          campo.cod == "POMO_ST" ||
          campo.cod == "POMO"
        ) {
          //POMO_ST-COLOR_PERFIL_ST&00-CR.webp
          //console.log(acabado.cod.padStart(2, "0"));

          if (acabado.cod.padStart(2, "0") == "00") {
            nombre = "POMO_ST&00";
          } else {
            nombre =
              "POMO_ST" +
              "-" +
              "COLOR_PERFIL_ST" +
              "&" +
              acabado.cod.padStart(2, "0") +
              "-" +
              campo.compuesto.acabadoSel.cod;
          }
        } else {
          nombre =
            campo.cod +
            "-" +
            campo.compuesto.cod +
            "&" +
            acabado.cod +
            "-" +
            campo.compuesto.acabadoSel.cod;
        }
      } else if (campo.campoFiltro != undefined) {
        nombre =
          campo.campoFiltro.cod +
          "-" +
          campo.cod +
          "&" +
          acabado.cod +
          "-" +
          campo.acabadoSel.cod;
      } else {
        if (campo.cod == "vidrio") {
          if (acabado.cod == "0" || acabado.cod == "00") {
            // Incoloro
            nombre = "TIPO_VIDRIO" + "&" + "01";
          } else {
            // Siempre es en color blanco...
            let colorDecorado = "01";
            // Excepto...
            if (
              this.aplicacion.colecciones[0].cod.toUpperCase() == "MINDANAO"
            ) {
              if (acabado.cod == "38") {
                colorDecorado = "02";
              }
            }

            nombre =
              "DECORADO-COLOR_DECORADO" +
              "&" +
              acabado.cod.padStart(2, "0") +
              "-" +
              colorDecorado;
          }
        } else {
          if (campo.cod == "perfil") {
            nombre = "COLOR_PERFIL_ST" + "&" + acabado.cod;
          } else {
            nombre = campo.cod + "&" + acabado.cod;
          }
        }
      }
      return nombre;
    },
    GetTaco(campo, acabado) {
      return this.GetNombreArchivo(campo, acabado) + ".webp";
    },
    GetModal(campo, acabado) {
      return this.GetNombreArchivo(campo, acabado) + "&MODAL.webp";
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  width: 350px;
  height: 100%;
  margin-right: -350px;
  background-color: rgb(243, 244, 246);
  -webkit-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -moz-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -ms-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -o-transition: margin-right 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  transition: margin-right 0.35s ease-in-out, background-color 0.35s ease-in-out;

  &__caracteristicas {
    background-color: #f3f4f6;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    width: 100%;
    height: 100%;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;

    &__tipos {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: center;
      padding: 25px 25px 0px 25px;
      width: 100%;

      &__title {
        color: black;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 10px;
        -webkit-transition: color 0.35s ease-in-out;
        -moz-transition: color 0.35s ease-in-out;
        -ms-transition: color 0.35s ease-in-out;
        -o-transition: color 0.35s ease-in-out;
        transition: color 0.35s ease-in-out;
      }

      &__items {
        opacity: 1;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        align-content: center;
        width: 100%;
        height: 35px;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;

        &__item {
          text-align: center;
          color: black;
          opacity: 0.35;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 35%;
          height: 35px;
          font-size: 13px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;

          &:first-child {
            border-radius: 5px 0px 0px 5px;
            border-top: 1px solid black;
            border-left: 1px solid black;
            border-bottom: 1px solid black;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }

          &:last-child {
            border-radius: 0px 5px 5px 0px;
            border-top: 1px solid black;
            border-right: 1px solid black;
            border-bottom: 1px solid black;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }

          &.active {
            opacity: 1;
            pointer-events: none;
            color: white;
            background-color: #4c88b7;
            width: 65%;
            border-top: 1px solid transparent;
            border-right: 1px solid transparent;
            border-bottom: 1px solid transparent;
            border-left: 1px solid transparent;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }

          &:hover {
            opacity: 0.8;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }
      }

      &.hidden {
        display: none;
      }

      &.error {
        pointer-events: none;

        & .menu__caracteristicas__tipos {
          &__items {
            opacity: 0.3;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }
      }
    }

    &__grupos {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      width: 100%;
      height: auto;
      padding: 15px 25px 0px 25px;

      &__item {
        opacity: 1;
        margin-top: 0px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        width: 100%;
        -webkit-transition: opacity 0.35s ease-in-out,
          margin-top 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;

        &__grupo {
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          align-content: center;
          width: 100%;
          height: 38px;
          background-color: transparent;
          padding: 8px 12px;
          border-radius: 5px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;

          &__name {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            align-content: center;

            &__error {
              opacity: 0;
              width: 0px;
              height: 0px;
              margin-right: 0px;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }

            &__texto {
              color: black;
              font-size: 14px;
              line-height: 14px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &.error {
              & .menu__caracteristicas__grupos__item__grupo__name {
                &__error {
                  opacity: 1;
                  width: 20px;
                  height: 20px;
                  margin-right: 10px;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }
          }

          &__expand {
            position: absolute;
            top: calc((38px - 22px) / 2);
            right: 12px;
            height: 22px;
            filter: invert(0%) brightness(100%);
            transform: rotate(0deg);
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }

        &__separator {
          opacity: 1;
          width: 100%;
          height: 0.01em;
          background-color: black;
          -webkit-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          -o-transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;
          transition: opacity 0.35s ease-in-out,
            0.35s background-color ease-in-out;

          &.hidden {
            opacity: 0;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }

        &.active {
          & .menu__caracteristicas__grupos__item {
            &__grupo {
              background-color: black;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__name {
                &__texto {
                  color: white;
                  -webkit-transition: color 0.35s ease-in-out;
                  -moz-transition: color 0.35s ease-in-out;
                  -ms-transition: color 0.35s ease-in-out;
                  -o-transition: color 0.35s ease-in-out;
                  transition: color 0.35s ease-in-out;
                }
              }

              &__expand {
                filter: invert(100%) brightness(100%);
                transform: rotate(180deg);
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }

            &__separator {
              opacity: 0;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }
          }
        }

        &.hidden {
          opacity: 0;
          margin-top: -38px;
          pointer-events: none;
          -webkit-transition: opacity 0.35s ease-in-out,
            margin-top 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out,
            margin-top 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out,
            margin-top 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
        }

        &:not(.active):hover {
          & .menu__caracteristicas__grupos__item {
            &__grupo {
              &__expand {
                top: 14px;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
          }
        }

        &:nth-last-child(2) {
          & .menu__caracteristicas__grupos__item {
            &__separator {
              display: none;
            }
          }
        }
      }

      &__separator {
        margin-top: 25px;
        width: 100%;
        height: 4px;
        background-color: black;
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;
      }
    }

    &__campos {
      position: relative;
      overflow-x: hidden !important;
      opacity: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      width: 100%;
      height: 100%;
      overflow: scroll;
      padding: 25px;
      padding-right: 20px;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;

      &__item {
        width: 100%;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;

        &__acabados {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          &__title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;

            &__text {
              color: black;
              font-weight: 600;
              font-size: 14px;
              line-height: 14px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &__ayuda {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              cursor: pointer;
              margin-left: 8px;

              &__info {
                filter: invert(0%);
                opacity: 1;
                height: 18px;
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }

              &__text {
                opacity: 0;
                pointer-events: none;
                position: absolute;
                top: 22px;
                left: 10px;
                border: 1px solid black;
                border-radius: 5px;
                width: 125px;
                background-color: #a6a6a6;
                color: white;
                font-size: 10px;
                padding: 8px;
                line-height: 12px;
                z-index: 15;
                -webkit-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, border 0.35s ease-in-out;
              }

              &:hover {
                & .menu__caracteristicas__campos__item__acabados__title__ayuda {
                  &__info {
                    opacity: 0.5;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }

                  &__text {
                    opacity: 1;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                  }
                }
              }
            }
          }

          &__items {
            display: grid;
            grid-auto-rows: 1fr;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 10px;

            &__item {
              transform: scale(1);
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              align-content: center;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__detalle {
                opacity: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                position: absolute;
                z-index: 10;
                right: 0px;
                top: 0px;
                background-color: black;
                border-radius: 0px 4px 0px 4px;
                width: 21px;
                height: 21px;
                padding: 2px;
                -webkit-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -moz-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -ms-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -o-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;

                &__image {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  filter: invert(100%);
                }

                &:hover {
                  background-color: grey;
                  -webkit-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -moz-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -ms-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -o-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                }
              }

              &__miniatura {
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                background-image: url("@/assets/Images/Global/Transparente.webp");
                background-repeat: no-repeat;
                background-position: center;
                background-size: 60%;
                width: 93.4px;
                height: 93.4px;
                border: 1px solid transparent;
                border-radius: 5px;
                padding: 4px;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;

                &__image {
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 2.5px;
                  -webkit-transition: opacity 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out;
                }

                &__error {
                  opacity: 0;
                  position: absolute;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  align-content: center;
                  pointer-events: none;
                  -webkit-transition: opacity 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out;

                  &__image {
                    height: 35px;
                  }

                  &__texto {
                    color: black;
                    margin-top: 10px;
                    font-size: 10px;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }
                }
              }

              &__name {
                color: black;
                font-size: 11px;
                line-height: 11px;
                max-width: 83.8px;
                margin-top: 5px;
                padding-left: 5px;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }

              &.active {
                & .menu__caracteristicas__campos__item__acabados__items__item {
                  &__miniatura {
                    border: 1px solid black;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }

              &:not(.active) {
                & .menu__caracteristicas__campos__item__acabados__items__item {
                  &__miniatura:hover {
                    border: 1px solid rgb(150, 150, 150, 0.7);
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }

              &.error {
                & .menu__caracteristicas__campos__item__acabados__items__item {
                  &__miniatura {
                    border: 1px solid #cc0000;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;

                    &__image {
                      opacity: 0.4 !important;
                      -webkit-transition: opacity 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out;
                    }

                    &__error {
                      opacity: 1;
                      -webkit-transition: opacity 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out;
                    }
                  }
                }
              }
            }
          }
        }

        &__compuesto {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          &__title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;

            &__text {
              color: black;
              font-weight: 600;
              font-size: 14px;
              line-height: 14px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &__ayuda {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              cursor: pointer;
              margin-left: 8px;

              &__info {
                filter: invert(0%);
                opacity: 1;
                height: 18px;
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }

              &__text {
                opacity: 0;
                pointer-events: none;
                position: absolute;
                top: 22px;
                left: 10px;
                border: 1px solid black;
                border-radius: 5px;
                width: 125px;
                background-color: #a6a6a6;
                color: white;
                font-size: 10px;
                padding: 8px;
                line-height: 12px;
                z-index: 15;
                -webkit-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, border 0.35s ease-in-out;
              }

              &:hover {
                &
                  .menu__caracteristicas__campos__item__compuesto__title__ayuda {
                  &__info {
                    opacity: 0.5;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }

                  &__text {
                    opacity: 1;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                  }
                }
              }
            }
          }

          &__filtros {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            align-content: center;
            margin-bottom: 15px;
            width: 100%;
            height: 35px;

            &__item {
              text-align: center;
              color: black;
              opacity: 0.35;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 35%;
              height: 35px;
              font-size: 13px;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &:first-child {
                border-radius: 5px 0px 0px 5px;
                border-top: 1px solid black;
                border-left: 1px solid black;
                border-bottom: 1px solid black;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }

              &:last-child {
                border-radius: 0px 5px 5px 0px;
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }

              &.active {
                opacity: 1;
                pointer-events: none;
                color: white;
                background-color: #4c88b7;
                width: 65%;
                border-top: 1px solid transparent;
                border-right: 1px solid transparent;
                border-bottom: 1px solid transparent;
                border-left: 1px solid transparent;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }

              &:hover {
                opacity: 0.8;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
          }

          &__items {
            opacity: 1;
            display: grid;
            grid-auto-rows: 1fr;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 10px;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;

            &__item {
              transform: scale(1);
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              align-content: center;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__detalle {
                opacity: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                position: absolute;
                z-index: 10;
                right: 0px;
                top: 0px;
                background-color: black;
                border-radius: 0px 4px 0px 4px;
                width: 21px;
                height: 21px;
                padding: 2px;
                -webkit-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -moz-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -ms-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -o-transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                transition: background-color 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;

                &__image {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  filter: invert(100%);
                }

                &:hover {
                  background-color: grey;
                  -webkit-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -moz-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -ms-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -o-transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  transition: background-color 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                }
              }

              &__miniatura {
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                background-image: url("@/assets/Images/Global/Transparente.webp");
                background-repeat: no-repeat;
                background-position: center;
                background-size: 60%;
                width: 93.4px;
                height: 93.4px;
                border: 1px solid transparent;
                border-radius: 5px;
                padding: 4px;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;

                &__image {
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 2.5px;
                  -webkit-transition: opacity 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out;
                }

                &__error {
                  opacity: 0;
                  position: absolute;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  align-content: center;
                  pointer-events: none;
                  -webkit-transition: opacity 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out;

                  &__image {
                    height: 35px;
                  }

                  &__texto {
                    color: black;
                    margin-top: 10px;
                    font-size: 10px;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }
                }
              }

              &__name {
                color: black;
                font-size: 11px;
                line-height: 11px;
                max-width: 83.8px;
                margin-top: 5px;
                padding-left: 5px;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }

              &.active {
                & .menu__caracteristicas__campos__item__compuesto__items__item {
                  &__miniatura {
                    border: 1px solid black;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }

              &:not(.active) {
                & .menu__caracteristicas__campos__item__compuesto__items__item {
                  &__miniatura:hover {
                    border: 1px solid rgb(150, 150, 150, 0.7);
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }

              &.error {
                & .menu__caracteristicas__campos__item__compuesto__items__item {
                  &__miniatura {
                    border: 1px solid #cc0000;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;

                    &__image {
                      opacity: 0.4 !important;
                      -webkit-transition: opacity 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out;
                    }

                    &__error {
                      opacity: 1;
                      -webkit-transition: opacity 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out;
                    }
                  }
                }
              }
            }
          }
        }

        &__dropdown {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          &__title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;

            &__text {
              color: black;
              font-weight: 600;
              font-size: 14px;
              line-height: 14px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &__ayuda {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              cursor: pointer;
              margin-left: 8px;

              &__info {
                filter: invert(0%);
                opacity: 1;
                height: 18px;
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }

              &__text {
                opacity: 0;
                pointer-events: none;
                position: absolute;
                top: 22px;
                left: 10px;
                border: 1px solid black;
                border-radius: 5px;
                width: 125px;
                background-color: #a6a6a6;
                color: white;
                font-size: 10px;
                padding: 8px;
                line-height: 12px;
                z-index: 15;
                -webkit-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, border 0.35s ease-in-out;
              }

              &:hover {
                & .menu__caracteristicas__campos__item__dropdown__title__ayuda {
                  &__info {
                    opacity: 0.5;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }

                  &__text {
                    opacity: 1;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                  }
                }
              }
            }
          }

          &__item {
            position: relative;
            width: 100%;

            &__selected {
              color: black;
              background-color: transparent;
              cursor: pointer;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              align-content: center;
              border: 1px solid black;
              padding: 8px 12px;
              border-radius: 5px;
              height: 40px;
              position: relative;
              background-color: rgb(243, 244, 246);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__value {
                opacity: 1;
                font-size: 14px;
                line-height: 14px;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }

              &__expand {
                height: 22px;
                transform: rotate(0deg);
                -webkit-transition: filter 0.35s ease-in-out,
                  transform 0.35s ease-in-out;
                -moz-transition: filter 0.35s ease-in-out,
                  transform 0.35s ease-in-out;
                -ms-transition: filter 0.35s ease-in-out,
                  transform 0.35s ease-in-out;
                -o-transition: filter 0.35s ease-in-out,
                  transform 0.35s ease-in-out;
                transition: filter 0.35s ease-in-out,
                  transform 0.35s ease-in-out;
              }
            }

            &__values {
              opacity: 0;
              pointer-events: none;
              position: absolute;
              top: 40px;
              left: 0px;
              width: 100%;
              background-color: rgb(245, 245, 245);
              border: 1px solid black;
              border-radius: 0px 0px 5px 5px;
              z-index: 10;
              -webkit-transition: opacity 0.35s ease-in-out,
                top 0.35s ease-in-out, color 0.35s ease-in-out,
                border 0.35s ease-in-out, background-color 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                color 0.35s ease-in-out, border 0.35s ease-in-out,
                background-color 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                color 0.35s ease-in-out, border 0.35s ease-in-out,
                background-color 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                color 0.35s ease-in-out, border 0.35s ease-in-out,
                background-color 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                color 0.35s ease-in-out, border 0.35s ease-in-out,
                background-color 0.35s ease-in-out;

              &__item {
                cursor: pointer;
                color: black;
                padding: 0px 0px;
                font-size: 0px;
                line-height: 0px;
                background-color: transparent;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;

                &:hover {
                  background-color: rgb(220, 220, 220);
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }

                &:last-child {
                  border-radius: 0px 0px 5px 5px;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }

                &.active {
                  color: white;
                  background-color: rgb(76, 136, 183);
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }

            &.open {
              & .menu__caracteristicas__campos__item__dropdown__item {
                &__selected {
                  border-radius: 5px 5px 0px 0px;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;

                  &__expand {
                    transform: rotate(180deg);
                    -webkit-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    -moz-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    -ms-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    -o-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                  }
                }

                &__values {
                  opacity: 1;
                  pointer-events: visible;
                  top: 38.9px;
                  -webkit-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                    color 0.35s ease-in-out, border 0.35s ease-in-out,
                    background-color 0.35s ease-in-out;

                  &__item {
                    font-size: 14px;
                    line-height: 14px;
                    padding: 7px 12px;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }
            }

            &:not(.open):hover {
              & .menu__caracteristicas__campos__item__dropdown__item {
                &__selected {
                  background-color: rgb(220, 220, 220);
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }
          }
        }

        &__input {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          &__title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;

            &__text {
              color: black;
              font-weight: 600;
              font-size: 14px;
              line-height: 14px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &__ayuda {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              cursor: pointer;
              margin-left: 8px;

              &__info {
                filter: invert(0%);
                opacity: 1;
                height: 18px;
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }

              &__text {
                opacity: 0;
                pointer-events: none;
                position: absolute;
                top: 22px;
                left: 10px;
                border: 1px solid black;
                border-radius: 5px;
                width: 125px;
                background-color: #a6a6a6;
                color: white;
                font-size: 10px;
                padding: 8px;
                line-height: 12px;
                z-index: 15;
                -webkit-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, border 0.35s ease-in-out;
              }

              &:hover {
                & .menu__caracteristicas__campos__item__input__title__ayuda {
                  &__info {
                    opacity: 0.5;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }

                  &__text {
                    opacity: 1;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                  }
                }
              }
            }
          }

          &__items {
            transform: scale(1);
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;
            width: 100%;
            -webkit-transition: transform 0.35s ease-in-out;
            -moz-transition: transform 0.35s ease-in-out;
            -ms-transition: transform 0.35s ease-in-out;
            -o-transition: transform 0.35s ease-in-out;
            transition: transform 0.35s ease-in-out;

            &__item {
              font-size: 14px;
              line-height: 14px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              align-content: center;
              width: 100%;
              height: 40px;
              border: 1px solid black;
              border-radius: 5px;
              background-color: rgb(243, 244, 246);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__input {
                color: black;
                height: 100%;
                border: none;
                outline: none;
                border-radius: 5px;
                background-color: transparent;
                padding: 8px 12px;
                width: 100%;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }

              &__ t {
                padding: 8px 12px;
                border-left: 1px solid black;
                color: black;
                -webkit-transition: color 0.35s ease-in-out,
                  border-left 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out,
                  border-left 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out,
                  border-left 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out,
                  border-left 0.35s ease-in-out;
                transition: color 0.35s ease-in-out,
                  border-left 0.35s ease-in-out;
              }
            }

            &__error {
              opacity: 0;
              pointer-events: none;
              top: 45px;
              position: absolute;
              font-size: 11px;
              line-height: 11px;
              color: #cc0000;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }
          }

          &.error {
            & .menu__caracteristicas__campos__item__input__items {
              &__item {
                border: 1px solid #cc0000;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }

              &__error {
                opacity: 1;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }
          }
        }

        &__toggle {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          &__title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            &__text {
              color: black;
              font-weight: 600;
              font-size: 14px;
              line-height: 14px;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &__ayuda {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              cursor: pointer;
              margin-left: 8px;

              &__info {
                filter: invert(0%);
                opacity: 1;
                height: 18px;
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }

              &__text {
                opacity: 0;
                pointer-events: none;
                position: absolute;
                top: 22px;
                left: 10px;
                border: 1px solid black;
                border-radius: 5px;
                width: 125px;
                background-color: #a6a6a6;
                color: white;
                font-size: 10px;
                padding: 8px;
                line-height: 12px;
                z-index: 15;
                -webkit-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  border 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, border 0.35s ease-in-out;
              }

              &:hover {
                & .menu__caracteristicas__campos__item__toggle__title__ayuda {
                  &__info {
                    opacity: 0.5;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }

                  &__text {
                    opacity: 1;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      border 0.35s ease-in-out;
                  }
                }
              }
            }
          }

          &__toggle {
          }
        }

        &:not(:first-child) {
          margin-top: 35px;
        }

        &.pop {
          &
            .menu__caracteristicas__campos__item__acabados__items__item.active.error {
            transform: scale(1.15);
            -webkit-transition: transform 0.35s ease-in-out;
            -moz-transition: transform 0.35s ease-in-out;
            -ms-transition: transform 0.35s ease-in-out;
            -o-transition: transform 0.35s ease-in-out;
            transition: transform 0.35s ease-in-out;
          }

          &
            .menu__caracteristicas__campos__item__compuesto__items__item.active.error {
            transform: scale(1.15);
            -webkit-transition: transform 0.35s ease-in-out;
            -moz-transition: transform 0.35s ease-in-out;
            -ms-transition: transform 0.35s ease-in-out;
            -o-transition: transform 0.35s ease-in-out;
            transition: transform 0.35s ease-in-out;
          }

          & .menu__caracteristicas__campos__item__input__items {
            transform: scale(1.1);
            -webkit-transition: transform 0.35s ease-in-out;
            -moz-transition: transform 0.35s ease-in-out;
            -ms-transition: transform 0.35s ease-in-out;
            -o-transition: transform 0.35s ease-in-out;
            transition: transform 0.35s ease-in-out;
          }
        }
      }
    }
  }

  &__grupos {
    background-color: #f3f4f6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;

    &__tipos {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      width: 100%;
      height: calc(100% / 6);
      border-top: 1px solid black;
      border-bottom: 1px solid black;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;

      &__title {
        display: none;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      &__items {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        align-content: center;
        width: 100%;
        height: 100%;

        &__item {
          text-align: center;
          color: black;
          opacity: 0.35;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50%;
          height: 100%;
          font-size: 16px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;

          &.active {
            opacity: 1;
            pointer-events: none;
            color: white;
            background-color: #4c88b7;
            width: 50%;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }

          &:hover {
            opacity: 0.8;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }
      }
    }

    &__item {
      opacity: 1;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      align-content: center;
      width: 100%;
      height: calc(100% / 6);
      -webkit-transition: border-bottom 0.35s ease-in-out,
        opacity 0.35s ease-in-out, height 0.35s ease-in-out;
      -moz-transition: border-bottom 0.35s ease-in-out,
        opacity 0.35s ease-in-out, height 0.35s ease-in-out;
      -ms-transition: border-bottom 0.35s ease-in-out, opacity 0.35s ease-in-out,
        height 0.35s ease-in-out;
      -o-transition: border-bottom 0.35s ease-in-out, opacity 0.35s ease-in-out,
        height 0.35s ease-in-out;
      transition: border-bottom 0.35s ease-in-out, opacity 0.35s ease-in-out,
        height 0.35s ease-in-out;

      &__error {
        opacity: 0;
        width: 0px;
        height: 0px;
        margin-right: 0px;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }

      &__text {
        color: black;
        pointer-events: none;
        -webkit-transition: color 0.35s ease-in-out;
        -moz-transition: color 0.35s ease-in-out;
        -ms-transition: color 0.35s ease-in-out;
        -o-transition: color 0.35s ease-in-out;
        transition: color 0.35s ease-in-out;
      }

      &:not(:last-child) {
        border-bottom: 1px solid black;
        -webkit-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        -moz-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        -ms-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        -o-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        transition: border-bottom 0.35s ease-in-out, opacity 0.35s ease-in-out,
          height 0.35s ease-in-out;
      }

      &.error {
        & .menu__grupos__item {
          &__error {
            opacity: 1;
            width: 20px;
            height: 20px;
            margin-right: 10px;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }
      }

      &.hidden {
        opacity: 0;
        pointer-events: none;
        height: 0px;
        -webkit-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        -moz-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        -ms-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        -o-transition: border-bottom 0.35s ease-in-out,
          opacity 0.35s ease-in-out, height 0.35s ease-in-out;
        transition: border-bottom 0.35s ease-in-out, opacity 0.35s ease-in-out,
          height 0.35s ease-in-out;
      }
    }

    &.hiddenTipos {
      & .menu__grupos {
        &__tipos {
          display: none;
        }

        &__item {
          height: calc(100% / 5);
          -webkit-transition: border-bottom 0.35s ease-in-out,
            opacity 0.35s ease-in-out, height 0.35s ease-in-out;
          -moz-transition: border-bottom 0.35s ease-in-out,
            opacity 0.35s ease-in-out, height 0.35s ease-in-out;
          -ms-transition: border-bottom 0.35s ease-in-out,
            opacity 0.35s ease-in-out, height 0.35s ease-in-out;
          -o-transition: border-bottom 0.35s ease-in-out,
            opacity 0.35s ease-in-out, height 0.35s ease-in-out;
          transition: border-bottom 0.35s ease-in-out, opacity 0.35s ease-in-out,
            height 0.35s ease-in-out;
        }
      }
    }
  }

  &__resumen {
    background-color: #f3f4f6;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    width: 100%;
    height: 100%;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;

    &__top {
      width: 100%;
      height: auto;
      padding: 25px 25px 0px 25px;

      &__title {
        color: black;
        font-size: 20px;
        line-height: 20px;
        border-bottom: 1px solid black;
        padding-bottom: 7px;
        -webkit-transition: border-bottom 0.35s ease-in-out,
          color 0.35s ease-in-out;
        -moz-transition: border-bottom 0.35s ease-in-out,
          color 0.35s ease-in-out;
        -ms-transition: border-bottom 0.35s ease-in-out, color 0.35s ease-in-out;
        -o-transition: border-bottom 0.35s ease-in-out, color 0.35s ease-in-out;
        transition: border-bottom 0.35s ease-in-out, color 0.35s ease-in-out;
      }
    }

    &__grupos {
      opacity: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      width: 100%;
      height: 100%;
      overflow: overlay;
      padding: 0px 25px 0px 25px;
      padding-right: 20px;
      overflow-x: hidden;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;

      &__item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: center;
        width: 100%;
        border-bottom: 1px solid black;
        padding: 15px 0px;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;

        &__title {
          color: black;
          font-weight: 600;
          font-size: 14px;
          line-height: 10px;
          margin-bottom: 10px;
          -webkit-transition: color 0.35s ease-in-out;
          -moz-transition: color 0.35s ease-in-out;
          -ms-transition: color 0.35s ease-in-out;
          -o-transition: color 0.35s ease-in-out;
          transition: color 0.35s ease-in-out;
        }

        &__campos {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          align-content: center;
          width: 100%;

          &__item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            align-content: center;
            width: 100%;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;

            &:not(:first-child) {
              margin-top: 20px;
            }

            &__title {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              align-content: center;

              &__campo {
                color: black;
                font-size: 15px;
                line-height: 15px;
                white-space: nowrap;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }

              &__value {
                color: black;
                white-space: nowrap;
                font-size: 13px;
                line-height: 13px;
                font-weight: 600;
                margin-top: 3px;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }
            }

            &__miniatura {
              background-image: url("@/assets/Images/Global/Transparente.webp");
              background-repeat: no-repeat;
              background-position: center;
              background-size: 60%;
              width: 83.8px;
              height: 83.8px;
              border: 1px solid transparent;
              border-radius: 5px;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__image {
                opacity: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 2.5px;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }

            &__value {
              color: black;
              white-space: nowrap;
              font-size: 13px;
              line-height: 13px;
              font-weight: 600;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }
          }
        }

        &:last-child {
          border-bottom: none;
        }

        &.hidden {
          opacity: 0;
          pointer-events: none;
          height: 0px;
          padding: 0px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }
      }
    }

    &__bottom {
      width: 100%;
      padding: 25px;

      &__buy {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        width: 100%;
        height: 40px;
        outline: none;
        border: none;
        color: white;
        background-color: black;
        border-radius: 5px;
        padding: 8px 12px;

        & p {
        }

        & img {
          opacity: 1;
          width: 35px;
          height: 35px;
          position: absolute;
          filter: invert(100%);
          right: 10px;
          pointer-events: none;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;

          &.hidden {
            opacity: 0;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }
      }
    }
  }

  &.open {
    margin-right: 0px;
    -webkit-transition: margin-right 0.35s ease-in-out;
    -moz-transition: margin-right 0.35s ease-in-out;
    -ms-transition: margin-right 0.35s ease-in-out;
    -o-transition: margin-right 0.35s ease-in-out;
    transition: margin-right 0.35s ease-in-out;
  }

  @media screen and (max-width: 950px) and (min-height: 600px) {
    z-index: 100000;
    margin-top: 60px;
    width: 100% !important;
    margin-right: 0px !important;
    height: calc(55dvh - 60px);
    margin-bottom: calc(-55dvh - 60px);
    -webkit-transition: all 0.35s ease-in-out;
    -moz-transition: all 0.35s ease-in-out;
    -ms-transition: all 0.35s ease-in-out;
    -o-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;

    &.open {
      margin-top: 40px;
      margin-bottom: 0px;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }

    &__caracteristicas {
      &__tipos {
        display: none;
      }

      &__campos {
        &__item {
          &__acabados {
            &__title {
              &__ayuda {
                display: none;
              }
            }

            &__items {
              grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

              @media screen and (max-width: 866px) {
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 758px) {
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 653px) {
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 550px) {
                grid-template-columns: 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 447px) {
                grid-template-columns: 1fr 1fr 1fr;
              }

              @media screen and (max-width: 343px) {
                grid-template-columns: 1fr 1fr;
              }

              @media screen and (max-width: 240px) {
                grid-template-columns: 1fr;
              }
            }
          }

          &__compuesto {
            &__title {
              &__ayuda {
                display: none;
              }
            }

            &__items {
              grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

              @media screen and (max-width: 868px) {
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 760px) {
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 655px) {
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 552px) {
                grid-template-columns: 1fr 1fr 1fr 1fr;
              }

              @media screen and (max-width: 449px) {
                grid-template-columns: 1fr 1fr 1fr;
              }

              @media screen and (max-width: 345px) {
                grid-template-columns: 1fr 1fr;
              }

              @media screen and (max-width: 242px) {
                grid-template-columns: 1fr;
              }
            }
          }

          &__dropdown {
            &__title {
              &__ayuda {
                display: none;
              }
            }
          }

          &__input {
            &__title {
              &__ayuda {
                display: none;
              }
            }
          }

          &__toggle {
            &__title {
              &__ayuda {
                display: none;
              }
            }
          }
        }
      }

      &__grupos {
        display: none;
      }
    }

    &__resumen {
      &__top {
        padding: 25px 20px 0px 25px;
      }

      &__grupos {
        &__item {
          &:last-child {
            border-bottom: none;
          }
        }
      }

      &__bottom {
      }
    }
  }

  @media screen and (max-height: 600px) {
    z-index: 100000;
    width: 247px;

    &__caracteristicas {
      &__tipos {
        display: none;
      }

      &__campos {
        &__item {
          &__acabados {
            &__title {
              &__ayuda {
                display: none;
              }
            }

            &__items {
              grid-template-columns: 1fr 1fr;
            }
          }

          &__compuesto {
            &__title {
              &__ayuda {
                display: none;
              }
            }

            &__items {
              grid-template-columns: 1fr 1fr;
            }
          }

          &__dropdown {
            &__title {
              &__ayuda {
                display: none;
              }
            }
          }

          &__input {
            &__title {
              &__ayuda {
                display: none;
              }
            }
          }

          &__toggle {
            &__title {
              &__ayuda {
                display: none;
              }
            }
          }
        }
      }

      &__grupos {
        display: none;
      }
    }

    &__grupos {
      &__tipos {
        border-top: 1px solid transparent;
      }
    }

    &__resumen {
      &__bottom {
        padding: 15px 25px 15px;

        &__cod {
          height: 30px;
          font-size: 13px;
          line-height: 13px;
        }
      }
    }
  }
}
</style>
